import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./css/index.css";
import "./css/global.css";
import "./assets/vendor/mdi/css/materialdesignicons.min.css";
import Router from "./components";
import * as serviceWorker from "./lib/serviceWorker";
import { exceptionInit } from "./lib/exceptionHandler";
import { Provider } from "react-redux";
// import configureStore from './redux/store';
import { store, persistor } from "./redux/store";
// import persistor from './redux/store';
import { BrowserRouter } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import history from "./lib/history";
import { PersistGate } from "redux-persist/integration/react";
import { registerAesKey } from "./lib/crypto";
// import * as Sentry from "@sentry/react";
import ErrorBoundary from "./components/ErrorBoundary";
import { QueryClient, QueryClientProvider } from "react-query";
import { QueryClientSetup } from "./QueryClientSetup";
import sentryInstance from "./lib/sentryIntegration";

registerAesKey();
sentryInstance.addSentry();

// remove console logs
const isThisProductionEnv = process.env.REACT_APP_MODE === "production";
if (isThisProductionEnv) {
  console.log = function () { };
  console.info = function () { };
  console.warn = function () { };
  console.error = function () { };
}

ReactDOM.render(
  // <Provider store={store}>
  //   <QueryClientProvider client={queryClient}>
  //   {/* <BrowserRouter> */}
  //     <PersistGate loading={null} persistor={persistor}>
  //       <ConnectedRouter history={history}>
  //         <ErrorBoundary>
  //           <Router />
  //         </ErrorBoundary>
  //       </ConnectedRouter>
  //     </PersistGate>
  //   {/* </BrowserRouter> */}
  //   </QueryClientProvider>
  // </Provider>,
  <QueryClientSetup />,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

exceptionInit();